import { useEffect, useState } from 'react';
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Avatar, Button, Chip, Stack } from '@mui/material';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { updateGlobalLoader } from '../../components/backdrop/backdropSlice';
import { CustomModal } from '../../components/modal';
import { useUpdateUserStatusMutation } from '../../redux/api';
import { getUserType } from '../../utils/common';
import { ADMIN, PENDING, TOOLTIP_STYLES } from '../../utils/constant';
import ProfileSummary from './ProfileSummary';
import { getEmail, getPhoneNumber, getUserDetailsById, getUserSocialDetailsById } from './action';
import { resetUser } from './userSlice';
import verifiedIcon from '../../assets/images/icons/verifiedIcon.svg'
import profileListIcon from '../../assets/images/icons/profileListIcon.svg'
import profileMailIcon from '../../assets/images/icons/profileMailIcon.svg'
import profilePhoneIcon from '../../assets/images/icons/profilePhoneIcon.svg'
import profileSummaryIcon from '../../assets/images/icons/profileSummaryIcon.svg'
import SocialProfileSummary from './SocialProfileSummary';
import approveWithBorderIcon from '../../assets/images/icons/approvedWithBorder.svg'
import deleteIcon from '../../assets/images/icons/deleteIconRed.svg'
const UserSocialDetails = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [open1, setOpen1] = useState(false);
    const [open2, setOpen2] = useState(false);
    const [modal, setModal] = useState({
        heading: "",
        submitButton: "",
        isError: false,
    });
    const { id } = useParams();
    const [value, setValue] = useState('1');
    const [data, setData] = useState([]);
    const [snackbar, setSnackbar] = useState({
        message: "",
        severity: "success",
        open: false,
    });
    const { details, userDetails, detailLoader } = useSelector((state) => state.userSlice);
    const handleChange = (event, newValue) => {
        setValue(newValue);
        setData(details.find((v) => v.handleName === newValue));
    };
    const [updateUser] = useUpdateUserStatusMutation();
    useEffect(() => {
        if (id) {
            dispatch(getUserSocialDetailsById(id, (status) => {
                if (status) {
                    dispatch(getUserDetailsById(id));
                }
            }));
            if (details?.length > 0) {
                setData(details[0]);
            }
        }
        return () => {
            dispatch(resetUser({ details: {} }));
        }
    }, [id]);
    const approveFunction = () => {
        setOpen(true);
        setModal({
            heading: "Approve User",
            submitButton: "Approve",
        });
    };
    const rejectFunction = () => {
        setOpen(true);
        setModal({
            heading: "Reject User",
            submitButton: "Reject",
            creating: false,
        });
    };
    const handleSubmit = (updateData) => {
        dispatch(updateGlobalLoader(true));
        updateUser({
            userId: [+id],
            status: updateData.status,
            description: updateData.description,
        }).then((res) => {
            dispatch(updateGlobalLoader(false));
            if (res.data.status == "SUCCESS") {
                setSnackbar({
                    open: true,
                    message: res.data.message,
                    severity: "success",
                });
            } else {
                setSnackbar({
                    open: true,
                    message: res.data.message,
                    severity: "error",
                });
            }
            setTimeout(() => {
                navigate("/userManagement/details/" + id);
                dispatch(getUserDetailsById(id));
            }, 500);
        });
    };
    return (
        <>
            <Stack direction="column" gap={3}>
                {getUserType() === ADMIN && <Stack direction={"row"} alignItems={"center"} className='justify-content-between' spacing={3} sx={{ padding: '16px' }}>
                    <Stack
                        direction={"row"}
                        alignItems={"center"}
                        justifyContent={"space-between"}
                        sx={{
                            minHeight: '42px',
                        }}>
                        <Typography variant="h1" className="page-title">
                            View Details
                        </Typography>
                        {getUserType() == ADMIN && <Stack
                            className="backText"
                            direction={"row"}
                            gap={1}
                            alignItems={"center"}
                            sx={{ cursor: "pointer" }}
                            onClick={() => navigate(-1)}>
                            <svg
                                width="16"
                                height="12"
                                viewBox="0 0 16 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M8.5 7.66667L5.16667 4.33333L8.5 1M4.33333 7.66667L1 4.33333L4.33333 1"
                                    stroke="#0077FF"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M5.1665 4.33331H10.9998C11.8839 4.33331 12.7317 4.6845 13.3569 5.30962C13.982 5.93474 14.3332 6.78259 14.3332 7.66665C14.3332 8.5507 13.982 9.39855 13.3569 10.0237C12.7317 10.6488 11.8839 11 10.9998 11H10.1665"
                                    stroke="#0077FF"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                            <Typography variant="h5" color={"primary"}>
                                Back
                            </Typography>
                        </Stack>}
                    </Stack>
                    <div className='appnrejbtn'>
                        {(userDetails?.status === PENDING && getUserType() == ADMIN) &&
                            <>
                                <Button sx={{ display: 'flex', alignItems: 'center', gap: 1, height: '44px', width: '130px', borderRadius: '8px', border: '2px solid #1EA750', background: 'white', "&:hover": { background: 'white', "& p": { color: '#1EA750' } } }} disableRipple onClick={() => approveFunction()}> <img src={approveWithBorderIcon} alt="approveWithBorderIcon" style={{ width: '20px', height: '20px' }} /> <Typography sx={{ color: '#1EA750', fontSize: '16px', fontWeight: 600 }}>Approve</Typography></Button>
                                <Button sx={{ display: 'flex', alignItems: 'center', gap: 1, height: '44px', width: '130px', borderRadius: '8px', border: '2px solid #EF3F3F', background: '#EF3F3F', "&:hover": { background: '#EF3F3F', "& p": { color: 'white' } } }} disableRipple className='btnDanger' onClick={() => rejectFunction()}> <img src={deleteIcon} alt="deleteIcon" style={{ width: '20px', height: '20px', filter: 'brightness(0) invert(1)' }} /><Typography sx={{ color: 'white', fontSize: '16px', fontWeight: 600 }}>Reject</Typography></Button>
                            </>
                        }
                    </div>
                </Stack>}
                <Box
                    sx={{
                        backgroundColor: '#fff',
                        transition: 'all .5s ease-in-out',
                        position: 'relative',
                        overflow: 'hidden',
                    }}>
                    <Box sx={{ border: '0px solid red', paddingX: '16px' }}>
                        <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"} padding={"20px"}>
                            <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"} gap={2} width={"50%"}>
                                <Avatar sx={{ height: '94px', width: '94px' }} src={userDetails?.picture ? userDetails?.picture : "/profile1.jpg"} />
                                <Stack direction={"column"} gap={1} sx={{ border: '0px solid red', height: '94px', width: '100%' }}>
                                    <Stack direction={"row"} justifyContent={"flex-start"} alignItems={"center"} gap={1}>
                                        <Typography fontSize={16} fontWeight={500} color={"#000000"} textTransform={"capitalize"}>{userDetails?.name}</Typography> <img src={verifiedIcon} alt="verifiedIcon" height={16} width={16} />
                                    </Stack>
                                    {userDetails?.profileNiche?.length > 0 && <Stack direction={"row"} justifyContent={"flex-start"} gap={1} alignItems={"center"} flexWrap={"wrap"}>
                                        {userDetails?.profileNiche.slice(0, 3)?.map((item) => <Tooltip
                                            title={item?.option || item}
                                            arrow
                                            componentsProps={TOOLTIP_STYLES}>
                                            <Chip
                                                key={item?.id || item}
                                                label={(item?.option || item)?.length > 20 ? (item?.option || item)?.slice(0, 20) + '...' : item?.option || item}
                                                sx={{
                                                    flexDirection: 'row',
                                                    background: 'white !important', color: '#726C6C !important',
                                                    borderRadius: '62px', border: '1px solid #CCCBCB', fontSize: '12px', fontWeight: '500',
                                                    height: '32px', "&:hover": {
                                                        background: 'rgba(0, 0, 0, 0.04) !important',
                                                    },
                                                    "& .css-6od3lo-MuiChip-label ": {
                                                        padding: '2px 4px'
                                                    }
                                                }}
                                            /></Tooltip>)}
                                    </Stack>}
                                    <Stack direction={"row"}>
                                        {userDetails?.city && <FmdGoodOutlinedIcon sx={{ fontSize: 16, color: "#726C6C" }} />}
                                        <Typography fontSize={12} fontWeight={400} color={'#726C6C'}>
                                            {userDetails?.city ? userDetails?.city?.toString() + ", " : ""}{userDetails.gender}
                                        </Typography>
                                    </Stack>
                                </Stack>
                            </Stack>
                            <Stack direction={"row"} justifyContent={"flex-end"} alignItems={"center"} gap={2} width={"50%"}>
                                {getUserType() === ADMIN ? <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-4 col-4" >
                                    <div className='influDetphEm'>
                                        <div className='influDetphEmItem mb-3'>
                                            <label>Phone:</label>
                                            <span>{userDetails?.phoneCountryCode + "-" + userDetails?.phoneNumber}</span>
                                        </div>
                                        <div className='influDetphEmItem'>
                                            <label>Email:</label>
                                            <span>{userDetails?.email || "N/A"}</span>
                                        </div>
                                    </div>
                                </div>
                                    : <><Button sx={{ display: 'none', background: 'linear-gradient(125deg,rgba(255, 204, 112, 1) 0%, rgba(200, 80, 192, 1) 50%, rgba(65, 88, 208, 1) 100%)', padding: '0', borderRadius: ' 4px', margin: '0px', width: '140px', height: '40px' }}><Typography sx={{ color: 'white', margin: '2px', width: 'fit-content', height: '100%', fontSize: "16px", background: 'transparent', display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 600, "&:hover": { background: 'transparent', color: 'white' } }}>                        <img src={profileListIcon} alt="profileListIcon" style={{ height: '24px', width: '24px' }} />&nbsp;&nbsp; Add to List
                                    </Typography></Button>
                                        <Button
                                            onClick={() => {
                                                dispatch(getPhoneNumber(id, setOpen1));
                                            }}
                                            disabled={open1 || open2}
                                            sx={{
                                                width: '120px', height: '40px',
                                                borderRadius: '4px', position: 'relative', background: 'linear-gradient(90deg,rgba(255, 204, 112, 1) 0%, rgba(200, 80, 192, 1) 50%, rgba(65, 88, 208, 1) 100%)', padding: '2px', overflow: 'hidden',
                                            }}
                                        >
                                            <Typography sx={{
                                                display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '2px',
                                                width: '100%', background: 'white', color: '#000000', fontWeight: '500', fontSize: '16px', height: '100%', "&:hover": {
                                                    background: 'transparent', color: 'white', "img": {
                                                        filter: 'brightness(100)', mixBlendMode: 'screen'
                                                    }
                                                }
                                            }}>
                                                <img src={profilePhoneIcon} alt="profilePhoneIcon" style={{ height: '24px', width: '24px' }} />&nbsp;&nbsp;Contact
                                            </Typography>
                                        </Button><Button
                                            disabled={open1 || open2}
                                            onClick={() => {
                                                dispatch(getEmail(id, setOpen2));
                                            }}
                                            sx={{
                                                width: '100px', height: '40px',
                                                borderRadius: '4px', position: 'relative', background: 'linear-gradient(90deg,rgba(255, 204, 112, 1) 0%, rgba(200, 80, 192, 1) 50%, rgba(65, 88, 208, 1) 100%)', padding: '2px', overflow: 'hidden',
                                            }}
                                        >
                                            <Typography sx={{
                                                borderRadius: '2px',
                                                width: '100%', background: 'white', color: '#000000', fontWeight: '500', fontSize: '16px', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', "&:hover": {
                                                    background: 'transparent', color: 'white', "img": {
                                                        filter: 'brightness(100)', mixBlendMode: 'screen'
                                                    }
                                                }
                                            }}>
                                                <img src={profileMailIcon} alt="profileMailIcon" style={{ height: '24px', width: '24px' }} />&nbsp;&nbsp; Mail
                                            </Typography>
                                        </Button></>}
                            </Stack>
                        </Stack>
                    </Box>
                    {/* content */}
                    {details?.length > 0 ? <div className='tabsLayout'>
                        <Box sx={{ width: '100%', typography: 'body1' }}>
                            <TabContext value={value}>
                                <Box className="">
                                    <TabList sx={{
                                        borderBottom: "0.5px solid #F0F0F0",
                                        boxSizing: 'content-box',
                                        "& .MuiTabs-indicator": {
                                            backgroundColor: "blue", // active tab underline
                                            height: 2,
                                            position: 'absolute'
                                        },
                                        "& .MuiTab-root": {
                                            textTransform: "none",
                                            fontWeight: 500,
                                            minHeight: 48,
                                            color: "#726C6C",
                                            justifyContent: 'flex-start',
                                            maxWidth: 'revert',
                                            "&.Mui-selected": {
                                                color: "blue",
                                                width: 'revert',
                                                borderBottom: "2px solid blue",
                                            },
                                        },
                                    }} className=' px-4' onChange={handleChange} variant="scrollable"
                                        scrollButtons={details.length > 4}
                                        allowScrollButtonsMobile
                                        aria-label="scrollable force tabs example">
                                        <Tab iconPosition="start" sx={{
                                            border: value === "1" ? "0px solid #0077FF" : "0px solid orange", fontSize: '16px', fontWeight: 400, padding: '4px 8px'
                                        }} icon={<img src={profileSummaryIcon} alt="instagram" width={24} height={24} />} label="Profile Summary" value="1" />
                                        {details?.map((v, i) => <Tab sx={{
                                            border: value === v.handleName ? "0px solid #0077FF" : "", fontSize: '16px', fontWeight: 400, padding: '4px 8px'
                                        }} key={i} iconPosition="start" icon={v.platform === "instagram" ? <img src="/instagram.png" alt="instagram" width={24} height={24} /> : <img src="/youtube.svg" alt="youtube" width={24} height={24} />} label={v.handleName} value={v.handleName} />)}
                                    </TabList>
                                </Box>
                                <TabPanel value="1" className='p-0'>
                                    <ProfileSummary details={details} userDetails={userDetails} />
                                </TabPanel>
                                <TabPanel value={data?.handleName} className='p-0'>
                                    <SocialProfileSummary data={data} />
                                </TabPanel>
                            </TabContext>
                        </Box>
                    </div>
                        :
                        detailLoader ? <Typography p={2} variant="h1" bgcolor={"white"}>
                            Loading...
                        </Typography> : <Typography p={2} variant="h1" bgcolor={"white"}>
                            No Data  found
                        </Typography>
                    }
                </Box>
            </Stack >
            <CustomModal
                open={open}
                onClose={() => setOpen(!open)}
                modal={modal}
                approveFn={handleSubmit}
            />
        </>
    )
}
export default UserSocialDetails;